import styled from 'styled-components'
import {FormHelperText} from "@material-ui/core";

export const CheckboxLabel = styled.div`
  font-size: 14px;
`

export const StyledFormHelperText = styled(FormHelperText)`
  color: var(--error-main, #F44336) !important;
  margin: 0 0.875rem;
`